import React from "react";
import styled from "styled-components";

export default function Contact() {
  return (
      <Wrapper className="whiteBg" id="contact">
        <div >
          <div className="container">
            <HeaderInfo>
              <h1 className="font40 extraBold">Kontakte</h1>
            </HeaderInfo>
            <ContentWrapper className="flex">
              <MapWrapper>
                <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.340476619376!2d9.002543215909114!3d48.68554341935261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4799db637f9d9f1f%3A0x5f5aa5e8774b2324!2sSindelfinger%20Str.%2011%2C%2071032%20B%C3%B6blingen%2C%20Germany!5e0!3m2!1sen!2sde!4v1619992423209!5m2!1sen!2sde"
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
              </MapWrapper>
              <ContactInfo>
                <p className="font18"><strong>Adresse:</strong> Sindelfinger Str. 11, 71032 Böblingen</p>
                <p className="font18"><strong>Telefon:</strong> 07031-224724</p>
                <p className="font18"><strong>E-Mail:</strong> orient-hosseinzadeh@live.de</p>
                <p className="font18"><strong>Öffnungszeiten:</strong><br />
                  Montag bis Freitag: 10:00 – 18:00 Uhr<br />
                  Samstag: 9:00 – 14:00 Uhr
                </p>
              </ContactInfo>
            </ContentWrapper>
          </div>
        </div>
      </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 60px 0 0 0;
  padding-bottom: 20px;
`;

const HeaderInfo = styled.div`
  //padding: 0 0 30px 0;
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

const MapWrapper = styled.div`
  width: 60%;
  height: 400px;
  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
  @media (max-width: 860px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const ContactInfo = styled.div`
  width: 35%;
  padding-left: 20px;
  @media (max-width: 860px) {
    width: 100%;
    padding-left: 0;
  }
  p {
    margin: 10px 0;
  }
`;

